import React from 'react';
import PortfolioPage from '../PortfolioPage';

const SoftwareDevelopmentPortfolio = (props) => {
    return (
        <PortfolioPage {...props} id="Eng" title={`Software Portfolio`} subtitle={'Projects where I wrote a lot of code!'} list={'programming'} />
    )
}

export default SoftwareDevelopmentPortfolio;